import React from 'react'
import styled from 'styled-components'

import { useApiData } from '@hozana/api/hooks/useApiData'

import { AbsoluteDiv, TAbsoluteDivProps } from 'elements/layout/AbsoluteDiv'
import { Div } from 'elements/layout/Div'
import { Space } from 'elements/layout/Space'
import { BgImage } from 'elements/media/BgImage'
import { Loading } from 'elements/ui/Loading'

import { CommunityMembers } from 'modules/community/components/CommunityMembers'
import { getCommunityMembersLocationQuery } from 'modules/community/queries'
import type { TCommunity } from 'modules/community/types'

import { GMap } from './GMap'

const mapLoadingImage = '/img/map/map-loading-big.jpg'

const StyledAbsoluteDiv = styled(AbsoluteDiv)<TAbsoluteDivProps>`
  border-bottom: 1px solid ${(props) => props.theme.colors.black10};
  border-top: 1px solid ${(props) => props.theme.colors.black10};
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
`

export type TGoogleMapSectionProps = {
  community: TCommunity
}

export const GoogleMapSection = React.forwardRef<HTMLDivElement, TGoogleMapSectionProps>(({ community }, ref) => {
  const [membersLocation, membersLocationQuery] = useApiData(
    () => ({
      query: getCommunityMembersLocationQuery({ communityId: community.id }),
    }),
    [community.id],
  )

  return (
    <>
      <Space h="35px" />
      <Div h="100%" ref={ref}>
        <StyledAbsoluteDiv top="-35px" w="100%" zIndex="zIndex1" bg="white">
          <CommunityMembers community={community} fontSize="1em" m="10px" />
        </StyledAbsoluteDiv>
        {!membersLocation || membersLocationQuery.loading ? (
          <div style={{ height: '100%' }}>
            <BgImage h="100%" src={mapLoadingImage} align="middleCenter">
              <Loading />
            </BgImage>
          </div>
        ) : (
          <Div h="100%">
            {/* <Div h="100%" ref={this.mapDiv} /> */}
            <GMap membersLocation={membersLocation} />
          </Div>
        )}
      </Div>
    </>
  )
})

GoogleMapSection.displayName = 'GoogleMapSection'
